import { repairCodes } from '../fakeData';
export const calculateLaborSpecialRate = (tempRow) => {
    if (tempRow.repair) {
        tempRow.repairCode = repairCodes[tempRow.repair];
    }
    return tempRow;
};
